<template>
    <div class="flex-center my20">
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-sizes="[5, 10, 30, 50]" :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total" small>
        </el-pagination>
    </div>
</template>
<script>
export default {
    props: {
        total: {
            type: Number,
            default: 0
        },
        pageSize: {
            type: Number,
            default: 10
        },
        currentPage:{
            type: Number,
            default: 1
        }

    },
    data() {
        return {
           
        }
    },
    methods: {
        handleSizeChange(val) {
            this.$emit('handleSizeChange', val)
        },
        handleCurrentChange(val) {
            this.$emit('handleCurrentChange', val)

        }
    }
}
</script>
<style scoped>

/deep/ .el-pagination.is-background .el-pager li{
    background: #fff;
}

</style>